import React, {Component} from 'react';
import PropTypes from 'prop-types'
import LocaleStorageApp from '../../../js/utils/LocaleStorage'

class Gdpr extends Component {

    constructor(props) {
        super(props)
        this.state = {
            performanceChecked: LocaleStorageApp.has("gdpr-performance") ? LocaleStorageApp.get("gdpr-performance") === true : true,
            socialsChecked: LocaleStorageApp.has("gdpr-socials") ? LocaleStorageApp.get("gdpr-socials") === true : true,
        }

        this.handleChangePerformance = this.handleChangePerformance.bind(this)
        this.handleChangeSocials = this.handleChangeSocials.bind(this)
        this.onValidClicked = this.onValidClicked.bind(this)
    }

    onValidClicked() {
        if (this.props.handleValidClicked) {
            this.props.handleValidClicked({
                "gdpr-performance": this.state.performanceChecked,
                "gdpr-socials": this.state.socialsChecked
            })
        }
    }

    handleChangePerformance(e) {
        this.setState({performanceChecked: e.target.checked});
    }

    handleChangeSocials(e) {
        this.setState({socialsChecked: e.target.checked});
    }

    render() {
        const {popin} = this.props

        if (!popin) return null

        const renderHeader = () => {
            return (
                <div className="header">
                    <h4 className="section-title" dangerouslySetInnerHTML={{__html: `${this.props.gdprPopinTitle} <span class="dot background-primary-color"/>`}}/>
                </div>
            )
        }

        return (
            <div className="gdpr">
                {
                    popin && (
                        <div className="popin popin--cookie-preference">
                            {renderHeader()}
                            <div className="content">
                                <div className="input-checkbox">
                                    <input type="checkbox" name="gdpr-performance" id="gdpr-performance" checked={this.state.performanceChecked} onChange={this.handleChangePerformance}/>
                                    <label htmlFor="gdpr-performance"><span/><p dangerouslySetInnerHTML={{__html: this.props.gdprCheck1Title}}/></label>
                                    <div className="input-content" dangerouslySetInnerHTML={{__html: this.props.gdprCheck1Text}}/>
                                </div>
                                <div className="input-checkbox">
                                    <input type="checkbox" name="gdpr-socials" id="gdpr-socials" checked={this.state.socialsChecked} onChange={this.handleChangeSocials} />
                                    <label htmlFor="gdpr-socials"><span/><p dangerouslySetInnerHTML={{__html: this.props.gdprCheck2Title}}/></label>
                                    <div className="input-content" dangerouslySetInnerHTML={{__html: this.props.gdprCheck2Text}}/>
                                </div>
                            </div>
                            <div className="buttons-container">
                                <div className="button" onClick={this.onValidClicked} dangerouslySetInnerHTML={{__html: this.props.gdprValidCta}}/>
                            </div>
                            <div className="content infos-more" dangerouslySetInnerHTML={{__html: this.props.gdprInfosMore}}/>
                        </div>
                    )
                }
            </div>
        )
    }
}

Gdpr.propTypes = {
    popin: PropTypes.bool,
    gdprPopinTitle: PropTypes.string,
    gdprCheck1Title: PropTypes.string,
    gdprCheck1Text: PropTypes.string,
    gdprCheck2Title: PropTypes.string,
    gdprCheck2Text: PropTypes.string,
    gdprValidCta: PropTypes.string,
    gdprInfosMore: PropTypes.string,
    handleValidClicked: PropTypes.func.isRequired,
}

export default Gdpr



// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/gdpr/Gdpr.js